import React, { FunctionComponent } from 'react';
import { faVenusMars } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconGender: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faVenusMars} />;

export { BrassIconGender };
